var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"contacts","title":"Contact informations","columns":"1","schema":[
    {
      component: 'FInput',
      label: 'email',
      key: 'email',
    },
    {
      component: 'FInput',
      label: 'Telephone GB',
      key: 'tel_gb',
    },
    {
      component: 'FInput',
      label: 'Telephone US',
      key: 'tel_us',
    },
    {
      component: 'FInput',
      label: 'Telephone AU',
      key: 'tel_au',
    },
    {
      component: 'FInput',
      label: 'open hours on Monday',
      key: 'opening_hours_at_monday',
    },
    {
      component: 'FInput',
      label: 'open hours on Tuesday',
      key: 'opening_hours_at_tuesday',
    },
    {
      component: 'FInput',
      label: 'open hours on Wednesday',
      key: 'opening_hours_at_wednesday',
    },
    {
      component: 'FInput',
      label: 'open hours on Thursday',
      key: 'opening_hours_at_thursday',
    },
    {
      component: 'FInput',
      label: 'open hours on Friday',
      key: 'opening_hours_at_friday',
    },
    {
      component: 'FInput',
      label: 'open hours on Saturday',
      key: 'opening_hours_at_saturday',
    },
    {
      component: 'FInput',
      label: 'open hours on Sunday',
      key: 'opening_hours_at_sunday',
    } ],"submit":_vm.submit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }